import clsx from "clsx";

import { Tabs } from "@components/v2";

import { useTableStateDimensions } from "./hooks";
import { SalesTable } from "./sales-table";
import { TableSettings } from "./table-settings";
import { type TableState } from "./types";

interface Props {
  tableState: TableState;
  isMaximized?: boolean;
  onTableStateChange: (tableState: TableState) => void;
}

export const TableContent = ({
  tableState,
  isMaximized,
  onTableStateChange,
}: Props) => {
  const { breakdownDimension } = useTableStateDimensions(tableState);

  return (
    <div
      className={clsx("relative", {
        "h-full flex flex-col": isMaximized,
        "px-6": !isMaximized,
      })}
    >
      <div className="border-b border-v2-secondary flex items-center justify-between mb-4">
        <Tabs
          value={tableState.selectedTab}
          options={[
            { value: "breakdown", label: breakdownDimension.name },
            { value: "campaign", label: "Campaign" },
            { value: "adset", label: "Adset" },
            { value: "ad", label: "Ad" },
          ]}
          onChange={(selectedTab) => {
            let selection = {};

            if (["breakdown"].includes(selectedTab)) {
              selection = { ...selection, campaignSelection: [] };
            }

            if (["breakdown", "campaign"].includes(selectedTab)) {
              selection = { ...selection, adsetSelection: [] };
            }

            if (["breakdown", "campaign", "adset"].includes(selectedTab)) {
              selection = { ...selection, adSelection: [] };
            }

            onTableStateChange({
              ...tableState,
              selectedTab,
              ...selection,
              searchText: "",
              pageIndex: 0,
            });
          }}
        />
      </div>
      <div className="relative flex flex-col flex-1 gap-4 max-h-[calc(100%-124px)]">
        <TableSettings
          tableState={tableState}
          onTableStateChange={onTableStateChange}
          isMaximized={isMaximized}
        />
        <SalesTable
          tableState={tableState}
          onTableStateChange={onTableStateChange}
          isMaximized={isMaximized}
        />
      </div>
    </div>
  );
};
